import UnauthorizedPage from './UnauthorizedPagePresenter'

export default UnauthorizedPage
